// import type { RegionSelection, IFlashMessage } from './global';
import { writableSession } from './store-util';
export const megaPosts = writableSession('megaPosts', []);
